module.exports = __webpack_public_path__ + "static/media/loc2_img1.7ed38d1e.jpg";